'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookTheme = require('@narvar/nth-hook-theme');
var React = require('react');
var AppStore = require('../Icon/AppStore.js');
var GooglePlay = require('../Icon/GooglePlay.js');
var index = require('../StyledMarkup/index.js');
var index$1 = require('../TextLink/index.js');
var styles = require('./styles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Step = _ref => {
  let {
    title,
    details,
    children,
    links = []
  } = _ref;
  const {
    bodytextDefaultNone,
    iconsPrimaryNone,
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(styles.StyledOrderedListItem, {
    s: {
      fontFamily: bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontFamily,
      color: iconsPrimaryNone === null || iconsPrimaryNone === void 0 ? void 0 : iconsPrimaryNone.color,
      borderColor: iconsPrimaryNone === null || iconsPrimaryNone === void 0 ? void 0 : iconsPrimaryNone.color
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      ...bodytextDefaultNone,
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default["default"].createElement("strong", null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    content: title
  })), details && /*#__PURE__*/React__default["default"].createElement(styles.StyledStepSpan, null, details), links.length > 0 && /*#__PURE__*/React__default["default"].createElement(styles.StyledLinkContainer, null, links.map((link, i) => {
    let content = link.text;
    if (link.image) {
      const alt = typeof link.text === 'string' ? link.text : undefined;
      if (link.image === 'app_store') content = /*#__PURE__*/React__default["default"].createElement(AppStore["default"], {
        alt: alt
      });else if (link.image === 'google_play') {
        content = /*#__PURE__*/React__default["default"].createElement(GooglePlay["default"], {
          alt: alt
        });
      } else {
        content = /*#__PURE__*/React__default["default"].createElement("img", {
          src: link.image,
          alt: alt
        });
      }
    }
    return /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      key: i,
      href: link.url,
      linkStyle: {
        sDefault: linksNoneDefault,
        sHover: linksNoneHover
      }
    }, content);
  })), children));
};
var Step$1 = nthHookTheme.withThemeProvider(Step, {
  themeTokens: ['bodytextDefaultNone', 'iconsPrimaryNone', 'linksNoneDefault', 'linksNoneHover', 'buttonsPrimaryDefault', 'buttonsPrimaryHover']
});

exports["default"] = Step$1;
